import React, { useEffect, useState } from 'react';
import Button from '../../../components/ui/Button';
import { ModalShell } from '../../../components/ui/ModalFrame';
import { MODAL_LAYER } from '../../../constants/modalLayers';
import { MODAL_DIALOG_ACTIONS_END } from '../../../constants/layoutSpacing';
import { NOTIFICATION_CHANNELS } from '../../../utils/signatureFieldModel';
import { cn } from '../../../utils/cn';

/**
 * @param {{
 *   open: boolean;
 *   onCancel: () => void;
 *   onConfirm: (channel: 'Email' | 'Whatsapp') => void | Promise<void>;
 *   zClass?: string;
 * }} props
 */
const SignatureSendConfirmDialog = ({
  open,
  onCancel,
  onConfirm,
  zClass = MODAL_LAYER.standard,
}) => {
  const [channel, setChannel] = useState(NOTIFICATION_CHANNELS.EMAIL);

  useEffect(() => {
    if (open) {
      setChannel(NOTIFICATION_CHANNELS.EMAIL);
    }
  }, [open]);

  if (!open) return null;

  return (
    <ModalShell
      zClass={zClass}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-lg max-w-md w-full p-6 shadow-elevation-lg"
    >
      <p className="text-base text-foreground mb-4">
        Documento validado com sucesso. Deseja enviar para assinatura?
      </p>

      <fieldset className="mb-6 space-y-2">
        <legend className="text-sm font-medium text-foreground mb-2">
          Como notificar os signatários?
        </legend>
        <label
          className={cn(
            'flex items-start gap-3 rounded-lg border px-3 py-2.5 cursor-pointer transition-colors',
            channel === NOTIFICATION_CHANNELS.EMAIL
              ? 'border-primary bg-primary/5'
              : 'border-border hover:border-primary/40'
          )}
        >
          <input
            type="radio"
            name="notification_channel"
            className="mt-1"
            checked={channel === NOTIFICATION_CHANNELS.EMAIL}
            onChange={() => setChannel(NOTIFICATION_CHANNELS.EMAIL)}
          />
          <span>
            <span className="block text-sm font-medium text-foreground">E-mail</span>
            <span className="block text-xs text-muted-foreground mt-0.5">
              Todos os signatários precisam ter e-mail salvo.
            </span>
          </span>
        </label>
        <label
          className={cn(
            'flex items-start gap-3 rounded-lg border px-3 py-2.5 cursor-pointer transition-colors',
            channel === NOTIFICATION_CHANNELS.WHATSAPP
              ? 'border-primary bg-primary/5'
              : 'border-border hover:border-primary/40'
          )}
        >
          <input
            type="radio"
            name="notification_channel"
            className="mt-1"
            checked={channel === NOTIFICATION_CHANNELS.WHATSAPP}
            onChange={() => setChannel(NOTIFICATION_CHANNELS.WHATSAPP)}
          />
          <span>
            <span className="block text-sm font-medium text-foreground">WhatsApp</span>
            <span className="block text-xs text-muted-foreground mt-0.5">
              Todos os signatários precisam ter telefone com DDD salvo.
            </span>
          </span>
        </label>
      </fieldset>

      <div className={MODAL_DIALOG_ACTIONS_END}>
        <Button variant="outline" onClick={onCancel}>
          Cancelar
        </Button>
        <Button onClick={() => onConfirm(channel)} iconName="Send">
          Enviar
        </Button>
      </div>
    </ModalShell>
  );
};

export default SignatureSendConfirmDialog;
